import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=49b5b0e7&"
import script from "./Discipline.vue?vue&type=script&lang=js&"
export * from "./Discipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b5b0e7')) {
      api.createRecord('49b5b0e7', component.options)
    } else {
      api.reload('49b5b0e7', component.options)
    }
    module.hot.accept("./Discipline.vue?vue&type=template&id=49b5b0e7&", function () {
      api.rerender('49b5b0e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Discipline.vue"
export default component.exports